import { FormItemPropTypes } from './default'

const FormItemReversedSwitchPropTypes = {
  ...FormItemPropTypes,
}

export default FormItemReversedSwitchPropTypes
